export default __webpack_public_path__ + "static/media/solucao-05.81c9dff0.webp";